import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { InvitationAccessLevel, InvitationStatusType } from '@vi-iot/client';

import { CommercialInvitationAccessLevel } from '@store';

import { PillType } from '../../../../../shared/components/pill/pill.model';

@Pipe({
  name: 'partnerAccessPills',
})
export class PartnerAccessPillsPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(
    type: CommercialInvitationAccessLevel,
    status: InvitationStatusType
  ): { type: PillType; text: string }[] {
    const result: { type: PillType; text: string }[] = [];

    switch (type) {
      case InvitationAccessLevel.Partner:
        result.push({
          type: PillType.neutral,
          text: this.translateService.instant(
            '+INSTALLATIONS.INSTALLATION.DEVICE_CARD.SHARE_DEVICE_MONITORING.COMPANY_PILE'
          ),
        });
        break;
      case InvitationAccessLevel.Consumer:
        result.push({
          type: PillType.neutral,
          text: this.translateService.instant(
            '+INSTALLATIONS.INSTALLATION.DEVICE_CARD.SHARE_DEVICE_MONITORING.COMPANY_CONSUMER'
          ),
        });
        break;
    }

    switch (status) {
      case InvitationStatusType.Accepted:
        result.push({
          type: PillType.success,
          text: this.translateService.instant(
            '+INSTALLATIONS.INSTALLATION.DEVICE_CARD.SHARE_DEVICE_MONITORING.INVITATION_ACCEPTED'
          ),
        });
        break;
      case InvitationStatusType.Pending:
        result.push({
          type: PillType.info,
          text: this.translateService.instant(
            '+INSTALLATIONS.INSTALLATION.DEVICE_CARD.SHARE_DEVICE_MONITORING.INVITATION_PENDING'
          ),
        });
        break;
      case InvitationStatusType.Rejected:
        result.push({
          type: PillType.error,
          text: this.translateService.instant(
            '+INSTALLATIONS.INSTALLATION.DEVICE_CARD.SHARE_DEVICE_MONITORING.INVITATION_REJECTED'
          ),
        });
        break;
      case InvitationStatusType.Expired:
        result.push({
          type: PillType.secondaryInverted,
          text: this.translateService.instant(
            '+INSTALLATIONS.INSTALLATION.DEVICE_CARD.SHARE_DEVICE_MONITORING.INVITATION_EXPIRED'
          ),
        });
        break;
      case InvitationStatusType.Canceled:
        result.push({
          type: PillType.errorInverted,
          text: this.translateService.instant(
            '+INSTALLATIONS.INSTALLATION.DEVICE_CARD.SHARE_DEVICE_MONITORING.INVITATION_CANCELED'
          ),
        });
        break;
      case InvitationStatusType.Terminated:
        result.push({
          type: PillType.errorInverted,
          text: this.translateService.instant(
            '+INSTALLATIONS.INSTALLATION.DEVICE_CARD.SHARE_DEVICE_MONITORING.INVITATION_TERMINATED'
          ),
        });
        break;
    }

    return result;
  }
}
